{
  "name": "make-fetch-happen",
  "version": "15.0.6",
  "description": "Opinionated, caching, retrying fetch client",
  "main": "lib/index.js",
  "files": [
    "bin/",
    "lib/"
  ],
  "scripts": {
    "test": "tap",
    "posttest": "npm run lint",
    "eslint": "eslint \"**/*.{js,cjs,ts,mjs,jsx,tsx}\"",
    "lint": "npm run eslint",
    "lintfix": "npm run eslint -- --fix",
    "postlint": "template-oss-check",
    "snap": "tap",
    "template-oss-apply": "template-oss-apply --force"
  },
  "repository": {
    "type": "git",
    "url": "git+https://github.com/npm/make-fetch-happen.git"
  },
  "keywords": [
    "http",
    "request",
    "fetch",
    "mean girls",
    "caching",
    "cache",
    "subresource integrity"
  ],
  "author": "GitHub Inc.",
  "license": "ISC",
  "dependencies": {
    "@gar/promise-retry": "^1.0.0",
    "@npmcli/agent": "^4.0.0",
    "@npmcli/redact": "^4.0.0",
    "cacache": "^20.0.1",
    "http-cache-semantics": "^4.1.1",
    "minipass": "^7.0.2",
    "minipass-fetch": "^5.0.0",
    "minipass-flush": "^1.0.5",
    "minipass-pipeline": "^1.2.4",
    "negotiator": "^1.0.0",
    "proc-log": "^6.0.0",
    "ssri": "^13.0.0"
  },
  "devDependencies": {
    "@npmcli/eslint-config": "^5.0.0",
    "@npmcli/template-oss": "4.25.0",
    "nock": "^13.2.4",
    "safe-buffer": "^5.2.1",
    "standard-version": "^9.3.2",
    "tap": "^16.0.0"
  },
  "engines": {
    "node": "^20.17.0 || >=22.9.0"
  },
  "tap": {
    "color": 1,
    "files": "test/*.js",
    "check-coverage": true,
    "timeout": 60,
    "nyc-arg": [
      "--exclude",
      "tap-snapshots/**"
    ]
  },
  "templateOSS": {
    "//@npmcli/template-oss": "This file is partially managed by @npmcli/template-oss. Edits may be overwritten.",
    "version": "4.25.0",
    "publish": "true"
  }
}
